module.exports = __webpack_public_path__ + "img/rekom-logo.b3d0eef5.png";